module.exports = __webpack_public_path__ + "img/Group@2x.f3710870.svg";